module.exports = __webpack_public_path__ + "img/LU.e6e76f35.svg";